import { render, staticRenderFns } from "./corporeity.vue?vue&type=template&id=0c0423b8&scoped=true&"
import script from "./corporeity.vue?vue&type=script&lang=ts&"
export * from "./corporeity.vue?vue&type=script&lang=ts&"
import style0 from "./corporeity.vue?vue&type=style&index=0&id=0c0423b8&prod&lang=scss&scoped=true&"
import style1 from "./corporeity.vue?vue&type=style&index=1&id=0c0423b8&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c0423b8",
  null
  
)

export default component.exports